<template>
    <div class="main-header-container">
        <div class="menu-wrap">
            <div class="menu-left">
                <img src="../../assets/image/app/logo.png" alt srcset />
            </div>
            <div class="menu-right hidden-sm-and-down">
                <ul>
                    <li class="drop-down">
                        <a href>
                            产品服务
                            <i class="el-icon-arrow-down"></i>
                        </a>
 
                        <ul class='ullin'>
                        <li class="puli">
                                 <div class="fl w50">
                                    <h2>产品服务</h2>
                                  <span> <a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong1.html">数据采集服务</a></span>
                                    <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong2.html">数据分析服务</a></span>
                                 <span> <a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong3.html">政府能管服务</a></span>   
                                 <span> <a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong4.html">售电管理服务</a></span> 
                                 <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong5.html">能效分析节能服务</a></span> 
                                 <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong6.html">用能安全管理服务</a></span>         
                                 <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong7.html">电力智能运维管理服务</a></span> 
                                 <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/xitong8.html">园区能源管理服务</a></span> 
                                 </div>
                                 <div class="fr w50">
                                        <h2>产品中心</h2>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong1.html">MMUT01多功能复费率三相智能电能采集器</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong2.html">MMUT01-S多功能复费率三相智能电能采集器-剩余电流</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong3.html">MWPT/SXY型面板式交流智能电能采集器</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong4.html">MWDT/S02型三相三/四线高压智能采集器</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong4a.html">MMCL01型LoRa通信单元</a></span> 
                                                 <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong5.html">MMCG03 4G物联网通信节点</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong6.html">MMHG03型红外智能采集器</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong7.html">MWJL01型数据集中器</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong8.html">DTSU2092-P型三相电子式电能表(导轨)</a></span>
                                            <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/pro_rong8.html">DTSU2092-D型三相电子式电能表（导轨)</a></span>
                                    </div>
                            </li>
                            
                        </ul>
                    </li>
                    <li class="drop-down">
                        <a href>
                            解决方案
                            <i class="el-icon-arrow-down"></i>
                        </a>
                        <ul class="ullin">
                            <li class="puli">
                                <div class="fl w50">
                                        <h2>重点解决方案</h2>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/fangan2.html">能效分析解决方案</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/fangan3.html">在线监测解决方案</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/fangan4.html">智慧园区解决方案</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/fangan5.html">智能运维服务解决方案</a></span>
                                    </div>
                                    <div class="fr w50">
                                        <h2>行业解决方案</h2>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/error.html">电力行业</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/error.html">工行业</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/error.html">纺织行业</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/error.html">汽车行业</a></span>
                                        <span><a target="_blank"
                                            href="http://test.motic-et.com/static/web/fangan1.html">大型商超</a></span>
                                    </div>
                            </li>
                             
                        </ul>
                    </li>
                    <li>
                       <a target="_blank"
                            href="http://test.motic-et.com/static/web/news.html">
                            资讯
                            <!-- <i class="el-icon-arrow-down"></i> -->
                        </a>
                    </li>
                    <li class="drop-down">
                        <a href="http://test.motic-et.com/static/bigScreen/index.html">
                            能源大数据
                            <!-- <i class="el-icon-arrow-down"></i> -->
                        </a>
                        <!-- <ul>
                            <li>
                                <a href="javascript:;" @click="goLogin">麦克奥迪智慧能源管理平台</a>
                            </li>
                        </ul> -->
                    </li>
                    <li>
                        <a href>城市合伙人</a>
                    </li>
                    <!-- <li>
                        <button class="login-btn" @click="goLogin">注册</button>
                    </li> -->
                    <li>
                        <button class="login-btn" @click="goLogin">登录</button>
                    </li>
                    <!-- <li class="drop-down">
                        <a style="top:-8px">
                            <img
                                style="width: 30px;height: 30px;"
                                src="../../assets/image/app/qrcode.png"
                                class="el-icon-arrow-down"
                            />
                        </a>
                        <ul>
                            <li>
                                <img
                                    style="width: 100%;height:100%"
                                    src="../../assets/image/app/qrcode.png"
                                />
                            </li>
                        </ul>
                    </li> -->
                    <!-- <li><div class="float-right serearch"><input type="text" ><i class="fa fa-search" aria-hidden="true"></i></div></li> -->
                </ul>
            </div>
            <!-- <div class="menu-right hidden-sm-and-up" @click="drawer = true">
                <i class="iconfont icon-caidan color-orange"></i>
            </div>-->
        </div>
        <el-drawer
            title="我是标题"
            :modal="true"
            direction="ltr"
            :visible.sync="drawer"
            :with-header="false"
        >
            <el-menu
                default-active="2"
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
                background-color="rgba(19, 39, 57, 0.8)"
                text-color="#ffffff"
                active-text-color="#f66f6a"
            >
                <el-menu-item index="1">
                    <span slot="title">首页</span>
                </el-menu-item>
                <el-submenu index="2">
                    <template slot="title">
                        <span>产品服务</span>
                    </template>
                    <el-menu-item index="2-1">
                        <span slot="title">售电服务</span>
                    </el-menu-item>
                    <el-menu-item index="2-2">
                        <span slot="title">配电智能运维</span>
                    </el-menu-item>
                    <el-menu-item index="2-3">
                        <span slot="title">购售电交流</span>
                    </el-menu-item>
                    <el-menu-item index="2-4">
                        <span slot="title">协同办公系统</span>
                    </el-menu-item>
                    <el-menu-item index="2-5">
                        <span slot="title">综合能源服务</span>
                    </el-menu-item>
                </el-submenu>
                <el-submenu index="3">
                    <template slot="title">
                        <span>解决方案</span>
                    </template>
                    <el-menu-item index="3-1">
                        <span slot="title">智慧园区</span>
                    </el-menu-item>
                    <el-menu-item index="3-2">
                        <span slot="title">工业园区</span>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="4">
                    <span slot="title">资讯信息</span>
                </el-menu-item>
                <el-submenu index="5">
                    <template slot="title">
                        <span>智慧能源管理平台</span>
                    </template>
                    <el-menu-item index="5-1">
                        <span slot="title">和信能源能源管理平台</span>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="6">
                    <span slot="title">招聘信息</span>
                </el-menu-item>
            </el-menu>
        </el-drawer>
    </div>
</template>
<script>
import * as api from "@/http/api.js";

export default {
    name: "Head",
    data() {
        return {
            drawer: false,
            logo_url: "",
            isShow: false
        };
    },
    created() {
        const systemInfo = JSON.parse(sessionStorage.getItem("systemInfo"));
        this.logo_url = systemInfo ? systemInfo.system_logo : "";
    },
    methods: {
        goLogin() {
            // const { href } = this.$router.resolve({
            //     path: "/login",
            // });
            // window.open(href, "_blank");
            this.$router.push("/login");
        }
    }
};
</script>
<style lang="scss">

.main-header-container {
    width: 100%;
background: #383838;position: fixed;z-index:9999;
    top: 0;
    right: 0;
    left: 0;

    .main-header {
        width: 100%;
        height: 44px;
        background: #2462a3;
        color: #fff;
        line-height: 44px;

        .main-header-inner {
            max-width: 1280px;
            height: 100%;
            clear: both;
            margin: 0 auto;
            padding: 0 10px;
            box-sizing: border-box;

            .header-left {
                width: calc(100% - 100px);
                float: left;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .login-btns {
                width: 100px;
                // display: inline-flex;
                text-align: right;
                // align-items: center;
                // justify-content: space-between;
                float: right;

                .login-btn {
                    cursor: pointer;
                    font-weight: bolder;

                    &:hover {
                        color: #e9895f;
                    }
                }
            }
        }
    }

    .menu-wrap {
        max-width: 1280px;
        height: 40px;
        margin: 0 auto;
        clear: both;
        padding: 8px 5px;

        .menu-left {
            height: 100%;
            float: left;
            height: 40px;

            img {
                height: 100%;
            }
        }

        .menu-right {
            float: right;
            padding-right: 5px;
            .color-orange {
                color: #e9895f;
            }

            .icon-caidan {
                font-size: 3rem;
            }

            ul > li {
                
                white-space: nowrap;
                float: left;
                margin-top: 2px;
            }

            a {
                display: block;
                position: relative;
                color:#FFF;
                padding: 10px 15px;
                transition: 0.3s;
                font-size: 14px;
                font-family: "Montserrat", sans-serif;
                font-weight: 500;
                .el-icon-arrow-down {
                    padding: 0 5px;
                }
            }

            a:hover,
            .active > a,
            li:hover > a {
                color: #f66f6a;
                text-decoration: none;
            }
            
            .drop-down ul {
                display: block;width:100%;
                position: absolute;
                left: 0;
                top: calc(100% + 30px);
                z-index: 999;
                opacity: 0;
         visibility:hidden;
                padding: 10px 0;
                background: rgb(56,56,56,0.9)!important;
                box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
                transition: ease all 0.3s; 
            }

            .drop-down:hover > ul {
                opacity: 0.9;
                top: 100%;
                visibility: visible;
            }
         .ullin{width: 100%;background: rgb(56,56,56,0.9)!important;}
         .ullin li .w50{
            width: 46%;
            line-height: 1.6;
        }
        .ullin li h2{
            font-size: 1.1rem;
            line-height: 3.0;
            margin-bottom: 20px;
            color: #FFF;
            font-weight: normal;
            text-indent: 1em;
            border-bottom: 1px solid #b4b4b4;}
            .ullin li span {
            float: left;
            width: 49%;
        }
     .ullin li.puli {
    width: 90%;
    min-height: 330px!important;
    left: 5%;
    top: 10px;
}
        .main-nav .drop-down .ullin li a {
            color: #FFF;
            font-size: 1.6rem;
        }
                    .drop-down li { 
                        position: relative;
                    }
        fr {
            float: right;
        }
               
            .drop-down ul a:hover,
            .drop-down ul .active > a,
            .drop-down ul li:hover > a {
                color: #f66f6a;

                .el-icon-arrow-down {
                    color: #f66f6a;
                }
            }
 

            .drop-down .drop-down:hover > ul {
                opacity: 1;
                top: 0;
                left: 100%;
            }

            .drop-down .drop-down > a {
                padding-right: 35px;
            }

            .login-btn {
                padding: 8px 25px;
                border-radius: 5px;

                color: #f66f6a;
                margin-left: 50px;
                border: none;
                font-size: 0.7rem;
            }
        }
    }

    .el-drawer__wrapper {
        background: rgba(19, 39, 57, 0.8);
    }

    .el-drawer__body {
        background: rgba(19, 39, 57, 0.8);
    }

    .el-drawer {
        width: 50% !important;
        background: rgba(19, 39, 57, 0.8);

        .el-menu-item {
            padding-left: 20px !important;
        }

        .el-submenu,
        .el-menu-item {
            min-width: 50% !important;
        }

        .el-menu-item.is-active {
            background-color: rgba(19, 39, 57, 0.8) !important;
        }
    }
}
</style>
